import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import ProgressReportTasks from "AdminProgressReports/routes/ProgressReportTasks";
export default store => {
  return {
    path: "progress-report-sets",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "progress-report-sets" */ "./components"),
          import(
            /* webpackChunkName: "progress-report-sets" */ "ProgressReport/modules/ProgressReportModule"
          ),
          import(
            /* webpackChunkName: "progress-report-sets" */ "AdminProgressReports/modules/AdminProgressReportsModule"
          ),
        ]).then(([importedModule0, importedModule1, importedModule2]) => {
          const component = importedModule0.default;
          const progressReportReducer = importedModule1;
          const adminProgressReportReducer = importedModule2;
          injectReducer(store, {
            key: progressReportReducer.NAME,
            reducer: progressReportReducer.default,
          });
          injectReducer(store, {
            key: adminProgressReportReducer.NAME,
            reducer: adminProgressReportReducer.default,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [ProgressReportTasks(store)],
  };
};
